export type EncounterDirectiveId = 'BALANCED_ROUTE' | 'LIQUIDITY_BOUNTY' | 'FLASH_SETTLEMENT'

export interface EncounterDirective {
  readonly id: EncounterDirectiveId
  readonly name: string
  readonly codename: string
  readonly glyph: string
  readonly risk: string
  readonly description: string
  readonly objective: string
  readonly hpMultiplier: number
  readonly speedMultiplier: number
  readonly spawnRateMultiplier: number
  readonly rewardMultiplier: number
  readonly clearBonus: number
  readonly color: string
}

export const ENCOUNTER_DIRECTIVES: Record<EncounterDirectiveId, EncounterDirective> = {
  BALANCED_ROUTE: {
    id: 'BALANCED_ROUTE', name: 'BALANCED ROUTE', codename: 'STANDARD', glyph: '◇', risk: 'LOW RISK',
    description: 'Maintain the sector baseline with no additional hostile modifiers.',
    objective: 'Clear the wave under standard network conditions.',
    hpMultiplier: 1, speedMultiplier: 1, spawnRateMultiplier: 1, rewardMultiplier: 1, clearBonus: 0, color: '#35d8ea',
  },
  LIQUIDITY_BOUNTY: {
    id: 'LIQUIDITY_BOUNTY', name: 'LIQUIDITY BOUNTY', codename: 'HIGH VALUE', glyph: '₮', risk: 'HIGH INTEGRITY',
    description: 'Hostiles carry reinforced integrity in exchange for substantially larger kill rewards.',
    objective: '+30% hostile integrity // +55% kill bounty.',
    hpMultiplier: 1.3, speedMultiplier: 1, spawnRateMultiplier: 1, rewardMultiplier: 1.55, clearBonus: 0, color: '#47f2a5',
  },
  FLASH_SETTLEMENT: {
    id: 'FLASH_SETTLEMENT', name: 'FLASH SETTLEMENT', codename: 'TIME ATTACK', glyph: '↯', risk: 'EXTREME TEMPO',
    description: 'Accelerate movement and formation cadence, then collect a fixed clear premium.',
    objective: '+25% hostile speed // +30% spawn rate // $900 clear bonus.',
    hpMultiplier: 1, speedMultiplier: 1.25, spawnRateMultiplier: 1.3, rewardMultiplier: 1, clearBonus: 900, color: '#ff4fd8',
  },
}

export const ENCOUNTER_DIRECTIVE_IDS = Object.keys(ENCOUNTER_DIRECTIVES) as EncounterDirectiveId[]
